import { FC, useEffect, useState } from "react";
import Prompt from "@/models/prompt/prompt";
import PromptCardSkeleton from "../components/PromptCardSkeleton";
import PromptCard from "../components/PromptCard";
import ReviewPromptDialog from "../components/ReviewPromptDialog";
import { User } from "@/models/users/User";
type Props = {
  search: string;
  loading: boolean;
  prompts: Prompt[];
  tenantUsers: User[];
  handleSearchChange: (search: string) => void;
};

const PendingPrompts: FC<Props> = ({
  search,
  loading,
  prompts,
  tenantUsers,
  handleSearchChange,
}) => {
  const [selectedPrompt, setSelectedPrompt] = useState<Prompt | undefined>();
  const [isReviewingPendingPrompt, setIsReviewingPendingPrompt] =
    useState(false);

  const handleReviewPendingPrompt = (prompt: Prompt) => {
    setSelectedPrompt(prompt);
    setIsReviewingPendingPrompt(true);
  };

  const handleCloseDialog = () => {
    setIsReviewingPendingPrompt(false);
    setSelectedPrompt(undefined);
  };

  useEffect(() => {
    handleSearchChange(search);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <div className="flex flex-col h-full">
      {loading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pb-2 pt-2">
          {Array.from({ length: 6 }).map((_, index) => (
            <PromptCardSkeleton key={index} />
          ))}
        </div>
      ) : prompts.length === 0 ? (
        <div className="h-full flex flex-col items-center justify-center text-xl text-muted-foreground flex-1">
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            Ingen afventende prompts
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pb-2 pt-2">
          {prompts.map((prompt) => (
            <PromptCard
              key={prompt.id}
              prompt={prompt}
              user={tenantUsers.find((u) => u.id === prompt.userId)}
              onClick={() => handleReviewPendingPrompt(prompt)}
            />
          ))}
        </div>
      )}
      {selectedPrompt && (
        <ReviewPromptDialog
          prompt={prompts.find((p) => p.id === selectedPrompt.id) as Prompt}
          isOpen={isReviewingPendingPrompt}
          onOpenChange={handleCloseDialog}
        />
      )}
    </div>
  );
};

export default PendingPrompts;
